import { Box, Stack, styled, Typography } from "@mui/material"

import usePoolDetails from "../../hooks/use-pool-details"
import { useTokenInfo } from "../../hooks/use-token-info"
import { NumberFont } from "../../theme"

import TokenLogo from "../TokenLogo"

type SwapMultiHopRouteProps = {
  route: {
    pool_addresses: string[]
    distance: number
    path: string[]
    amount_out: string
  }
}

export function SwapMultiHopRoute(props: SwapMultiHopRouteProps) {
  const { route } = props

  return (
    <Stack gap={1} sx={{ padding: 1 }}>
      <Typography variant="h6" fontWeight={700} lineHeight={1}>
        Path
      </Typography>
      <Stack direction="row" gap={1} alignItems={{ xs: "flex-start", sm: "center" }}>
        {route.path.map((path) => (
          <Stack key={path} direction="row" alignItems="center" gap={1}>
            <TokenDetails token={path} />
            {path !== route.path[route.path.length - 1] && <span>→</span>}
          </Stack>
        ))}
      </Stack>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        gap={1}
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{
          fontSize: "0.8rem",
          color: "var(--mui-palette-text-secondary)",
        }}
      >
        {route.pool_addresses.map((pool) => (
          <Stack key={pool} direction="row" alignItems="center" gap={1}>
            <PoolDetails pool={pool} />
            {pool !== route.pool_addresses[route.pool_addresses.length - 1] && (
              <Box
                sx={{
                  display: { xs: "none", sm: "inline" },
                }}
              >
                →
              </Box>
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}

export function PoolDetails({ pool }: { pool: string }) {
  const { data: poolDetails } = usePoolDetails(pool)

  if (!poolDetails) return <span>{pool}</span>

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <span>{poolDetails.ticker}</span> <span>(- {Number(poolDetails.fee) / 100}%)</span>
    </Stack>
  )
}

export function TokenDetails({ token }: { token: string }) {
  const [tokenInfo] = useTokenInfo(token)

  if (!tokenInfo) return <span>{token}</span>

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <TokenLogo tx={tokenInfo.logo} alt={tokenInfo.ticker} />
      {tokenInfo.ticker}
    </Stack>
  )
}

const DetailsRow = styled(Stack)(({ theme }) => ({
  gap: "var(--spacing)",
  justifyContent: "space-between",
  flexDirection: "row",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  "& > span:first-of-type": {
    whiteSpace: "nowrap",
    color: "var(--mui-palette-secondary)",
  },
  "& > span:last-of-type": {
    fontFamily: NumberFont,
    textAlign: "right",
  },
  "& > div:last-of-type": {
    fontFamily: NumberFont,
    textAlign: "right",
  },
}))
